import { useQuery, UseQueryOptions } from 'react-query';

import { Guid, AssociatedTeamMember } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDataRoomTeamMembersQuery(
	guid: Guid | undefined,
	options?:
		| Omit<UseQueryOptions<AssociatedTeamMember[], unknown, AssociatedTeamMember[], any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoomUsers.TeamMembersByRoom(guid),
		() =>
			AxiosUtils.getResponseData<AssociatedTeamMember[]>(
				api.get(CerebroApiEndpoints.DataRoomUsers.TeamMembersByRoom(guid))
			),
		options
	);
}
